import { ClientIntakeResponse } from '@db-access/clientIntakeResponses';
import { FieldResponseStatus } from '@models/client-intake';
import { IntakeResponseStatusCounts } from '@models/client-portal/client-intake-responses';

export const getLastResponse = (
	responses: ClientIntakeResponse[],
): ClientIntakeResponse | null => {
	if (!responses || responses.length === 0) {
		return null;
	}

	return responses.reduce((latest, response) => {
		return response?.updatedAt > latest?.updatedAt ? response : latest;
	}, responses[0]);
};

export const getAmountOfResponseSubmitted = (
	response: ClientIntakeResponse,
): number => {
	return (
		Object.keys(response?.formAnswers).filter(
			(key) => response.formAnswers[key]?.answer,
		).length ?? 0
	);
};

export const calculateProgress = (total: number, filled: number): number => {
	if (total === 0) {
		return 0;
	}

	return Math.round((filled / total) * 100);
};

export const getStatusCounts = (
	responses: ClientIntakeResponse[],
): IntakeResponseStatusCounts => {
	const allFormAnswers = responses.flatMap((response) =>
		Object.values(response.formAnswers || {}),
	);

	const filteredFormAnswers = allFormAnswers.filter(
		(answer) => answer.status !== FieldResponseStatus.CUSTOM,
	);

	const statusCounts = filteredFormAnswers.reduce(
		(counts, answer) => {
			switch (answer.status) {
				case FieldResponseStatus.READY_TO_REVIEW:
					counts.readyToReview++;
					break;
				case FieldResponseStatus.ADDED_TO_MATTER:
					counts.addedToMatter++;
					break;
				case FieldResponseStatus.MISSING_RESPONSES:
					counts.missingResponses++;
					break;
			}
			return counts;
		},
		{
			readyToReview: 0,
			addedToMatter: 0,
			missingResponses: 0,
		},
	);

	return {
		total: filteredFormAnswers.length,
		readyToReview: statusCounts.readyToReview,
		addedToMatter: statusCounts.addedToMatter,
		missingResponses: statusCounts.missingResponses,
	};
};
